import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { key: 1 };
const _hoisted_2 = ["aria-label"];
const _hoisted_3 = ["aria-label"];
const _hoisted_4 = {
    key: 0,
    class: "sidebar-fan__title"
};
import { nextTick, onBeforeUnmount, ref, watch } from "vue";
import { RouterLink, useRoute } from "vue-router";
import SidebarNavItem from "@/components/SidebarNavItem.vue";
const REOPEN_AFTER_PICK_MS = 400;
export default /*@__PURE__*/ _defineComponent({
    __name: 'SidebarFan',
    props: {
        icon: {},
        label: {},
        items: {},
        expanded: { type: Boolean },
        isMobile: { type: Boolean },
        route: { default: "" },
        active: { type: Boolean, default: false }
    },
    emits: ["navigate"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const currentRoute = useRoute();
        const open = ref(false);
        const keyboardOpen = ref(false);
        const inlineOpen = ref(false);
        const menu = ref(null);
        const panel = ref(null);
        let closedAt = 0;
        let hoverOpened = false;
        function close() {
            closedAt = Date.now();
            open.value = false;
        }
        /** A pick closes the fan; the hover still under the pointer must not reopen it straight away. */
        function onToggle(value) {
            if (value && Date.now() - closedAt < REOPEN_AFTER_PICK_MS)
                return;
            hoverOpened = value;
            open.value = value;
        }
        function pick(item) {
            close();
            item.action?.();
            emit("navigate");
        }
        function linkProps(item) {
            return item.to ? { to: item.to, "aria-current": item.active ? "page" : undefined } : { type: "button" };
        }
        function onParentClick() {
            if (props.route)
                close();
            else {
                hoverOpened = false;
                open.value = true;
            }
        }
        function panelItems() {
            return Array.from(panel.value?.querySelectorAll(".sidebar-fan__item") ?? []);
        }
        async function openAndFocusFirst() {
            hoverOpened = false;
            keyboardOpen.value = true;
            open.value = true;
            await nextTick();
            panelItems()[0]?.focus();
        }
        function onPanelKeydown(event) {
            const items = panelItems();
            const index = items.indexOf(document.activeElement);
            const last = items.length - 1;
            const targets = {
                ArrowDown: index < last ? index + 1 : 0,
                ArrowUp: index > 0 ? index - 1 : last,
                Home: 0,
                End: last,
            };
            if (!items.length || !(event.key in targets))
                return;
            event.preventDefault();
            items[targets[event.key]].focus();
        }
        /** Tabbing past a hover-opened fan moves on; VMenu would otherwise pull focus into the panel. */
        function onFocusIn(event) {
            const target = event.target;
            if (!hoverOpened || !target || menu.value?.activatorEl?.contains(target) || panel.value?.contains(target))
                return;
            close();
        }
        function onPlainClick() {
            emit("navigate");
        }
        function onMobileParent() {
            if (props.route)
                emit("navigate");
            else
                inlineOpen.value = !inlineOpen.value;
        }
        watch(() => currentRoute.fullPath, close);
        watch(open, (isOpen) => {
            if (isOpen)
                document.addEventListener("focusin", onFocusIn, true);
            else {
                keyboardOpen.value = false;
                document.removeEventListener("focusin", onFocusIn, true);
            }
        });
        onBeforeUnmount(() => document.removeEventListener("focusin", onFocusIn, true));
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_menu = _resolveComponent("v-menu");
            return (!__props.items.length)
                ? (_openBlock(), _createBlock(SidebarNavItem, {
                    key: 0,
                    icon: __props.icon,
                    label: __props.label,
                    route: __props.route,
                    expanded: __props.expanded,
                    active: __props.active,
                    onClick: onPlainClick
                }, null, 8, ["icon", "label", "route", "expanded", "active"]))
                : (__props.isMobile)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(SidebarNavItem, {
                            icon: __props.icon,
                            label: __props.label,
                            route: __props.route,
                            expanded: __props.expanded,
                            active: __props.active,
                            submenu: !__props.route,
                            "aria-expanded": __props.route ? undefined : String(inlineOpen.value),
                            onClick: onMobileParent
                        }, null, 8, ["icon", "label", "route", "expanded", "active", "submenu", "aria-expanded"]),
                        (__props.route || inlineOpen.value)
                            ? (_openBlock(), _createElementBlock("nav", {
                                key: 0,
                                class: "sidebar-fan__inline",
                                "aria-label": __props.label
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
                                    return (_openBlock(), _createBlock(_resolveDynamicComponent(item.to ? _unref(RouterLink) : 'button'), _mergeProps({
                                        key: item.key
                                    }, { ref_for: true }, linkProps(item), {
                                        class: ["sidebar-fan__inline-item", { 'sidebar-fan__inline-item--active': item.active }],
                                        onClick: ($event) => (pick(item))
                                    }), {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.label) + " ", 1),
                                            (item.external)
                                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                                    key: 0,
                                                    icon: "mdi-open-in-new",
                                                    size: "13",
                                                    class: "sidebar-fan__external"
                                                }))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                    }, 1040, ["class", "onClick"]));
                                }), 128))
                            ], 8, _hoisted_2))
                            : _createCommentVNode("", true)
                    ]))
                    : (_openBlock(), _createBlock(_component_v_menu, {
                        key: 2,
                        ref_key: "menu",
                        ref: menu,
                        "model-value": open.value,
                        location: "end",
                        offset: 8,
                        "open-on-hover": !keyboardOpen.value,
                        "open-on-focus": false,
                        "open-on-click": false,
                        "open-delay": 60,
                        "close-delay": 160,
                        transition: "sidebar-fan",
                        "content-class": "sidebar-fan",
                        "onUpdate:modelValue": onToggle
                    }, {
                        activator: _withCtx(({ props: menuProps }) => [
                            _createVNode(SidebarNavItem, _mergeProps(menuProps, {
                                icon: __props.icon,
                                label: __props.label,
                                route: __props.route,
                                expanded: __props.expanded,
                                active: __props.active,
                                submenu: "",
                                "tooltip-disabled": open.value,
                                onKeydown: [
                                    _withKeys(_withModifiers(openAndFocusFirst, ["prevent"]), ["right"]),
                                    _withKeys(close, ["esc"])
                                ],
                                onClick: onParentClick
                            }), null, 16, ["icon", "label", "route", "expanded", "active", "tooltip-disabled", "onKeydown"])
                        ]),
                        default: _withCtx(() => [
                            _createElementVNode("nav", {
                                ref_key: "panel",
                                ref: panel,
                                class: "sidebar-fan__panel",
                                "aria-label": __props.label,
                                onKeydown: onPanelKeydown
                            }, [
                                (!__props.expanded && __props.items[0]?.label !== __props.label)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.label), 1))
                                    : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
                                    return (_openBlock(), _createBlock(_resolveDynamicComponent(item.to ? _unref(RouterLink) : 'button'), _mergeProps({
                                        key: item.key
                                    }, { ref_for: true }, linkProps(item), {
                                        class: ["sidebar-fan__item", { 'sidebar-fan__item--active': item.active }],
                                        style: { '--sidebar-fan-index': index },
                                        onMouseenter: ($event) => (item.prefetch?.()),
                                        onFocus: ($event) => (item.prefetch?.()),
                                        onClick: ($event) => (pick(item))
                                    }), {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                                icon: item.icon,
                                                size: "18",
                                                class: "sidebar-fan__icon"
                                            }, null, 8, ["icon"]),
                                            _createElementVNode("span", null, _toDisplayString(item.label), 1),
                                            (item.external)
                                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                                    key: 0,
                                                    icon: "mdi-open-in-new",
                                                    size: "13",
                                                    class: "sidebar-fan__external"
                                                }))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                    }, 1040, ["class", "style", "onMouseenter", "onFocus", "onClick"]));
                                }), 128))
                            ], 40, _hoisted_3)
                        ]),
                        _: 1
                    }, 8, ["model-value", "open-on-hover"]));
        };
    }
});
